export default __webpack_public_path__ + "static/media/tool-icon-shirt-black-07.b4bed5d8.svg";